module.exports = __webpack_public_path__ + "img/IMG-20200119-WA0004.27f7c83b.jpg";